import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import { ICartItem } from '@/services/cart/models/cart';
import { Checkbox } from '@mui/material';
import { Box } from '@mui/system';
import VasVasApplicableCartItemSummary from './Summary';

type TVasApplicableCartItemProps = {
	item: ICartItem;
	price: string;
	isSelected: boolean;
	onAddClicked: (item: ICartItem) => void;
};

const VasApplicableCartItem = (props: TVasApplicableCartItemProps) => {
	const { item } = props;

	function onAddClicked() {
		props.onAddClicked(item);
	}

	return (
		<FlexBox alignItems='flex-start' pt='24px'>
			<Checkbox checked={props.isSelected} onChange={onAddClicked} />
			<FlexBox onClick={onAddClicked}>
				<Box mr='16px' className='cursor-pointer'>
					<img style={{ width: '113px' }} src={item.product.image} />
				</Box>
				<VasVasApplicableCartItemSummary price={props.price} item={item} />
			</FlexBox>
		</FlexBox>
	);
};

export default VasApplicableCartItem;
